/* eslint-disable react/prop-types, camelcase */
import React from 'react';

import Breadcrumbs from '~/modules/coreUI/components/basic/Breadcrumbs';
import BreadcrumbsLinks from '~/modules/ecommerceCore/BreadcrumbsLinks';

/*
Shop's Product Details:
Home >TRACK_NAME > DEPARTMENT_NAME > SHOP_NAME > DEPARTMENT_NAME > CATEGORY_NAME > PRODUCT_NAME

Product Details:
Home > Products > DEPARTMENT_NAME > CATEGORY_NAME > PRODUCT_NAME
*/

const ProductDetailsBreadcrumbs = props => (props.fromShops ? (
  <Breadcrumbs
    crumbs={[
      BreadcrumbsLinks.HOME(),
      BreadcrumbsLinks.SHOPS_TRACK(props.shop.vendor_track?.track_type, props.shop.vendor_track.name),
      BreadcrumbsLinks.SHOPS_DEPARTEMENT(props.shop.departments[0].ref_id, props.shop.departments[0].name, props.shop.vendor_track.track_type),
      BreadcrumbsLinks.SHOP(props.shop.ref_id, props.shop.name),
      BreadcrumbsLinks.PRODUCTS_DEPARTEMENT(props.variant.departments[0].ref_id, props.variant.departments[0].name),
      BreadcrumbsLinks.CATEGORY(props.category.ref_id, props.category.name),
      BreadcrumbsLinks.VARIANT(props.variant.slug, props.variant.name, props.shop),
    ]}
  />
) : (
  <Breadcrumbs
    crumbs={[
      BreadcrumbsLinks.HOME(),
      BreadcrumbsLinks.PRODUCTS(),
      BreadcrumbsLinks.PRODUCTS_DEPARTEMENT(props.variant.departments[0].ref_id, props.variant.departments[0].name),
      BreadcrumbsLinks.CATEGORY(props.category.ref_id, props.category.name),
      BreadcrumbsLinks.VARIANT(props.variant.slug, props.variant.name),
    ]}
  />
));

export default ProductDetailsBreadcrumbs;
